import { __awaiter, __generator } from "tslib";
import { element, isNumber } from 'angular';
import { isEqual } from 'lodash';
import { addToCart } from '@gn-audio/core/api/e-commerce/add-to-cart';
import { fetchGroupPrice } from '@gn-audio/core/api/pricing/fetch-group-price';
import { fetchProductPrice } from '@gn-audio/core/api/pricing/fetch-product-price';
import { getAvailabilityState } from '@gn-audio/core/api/pricing/utilities';
import { fetchEcomSetting } from '@gn-audio/core/api/site-settings/fetch-ecom-setting';
import addTemplate from './templates/add.template.html';
import backorderTemplate from './templates/back-order.template.html';
import preorderTemplate from './templates/pre-order.template.html';
import priceTemplate from './templates/price.template.html';
import whereToBuyTemplate from './templates/where-to-buy.template.html';
export var ProductActionDirective = [
    '$compile',
    '$q',
    function ($compile, $q) {
        return {
            link: function ($scope, $element) {
                var ecomSettings;
                var initEmptyPrice = function () {
                    $scope.price = { availabilityState: 3 /* WhereToBuy */ };
                };
                var execute = function () {
                    var _a, _b;
                    if (!ecomSettings || !ecomSettings.ecomEnabled) {
                        return;
                    }
                    var productSku = ((_a = $scope.price) === null || _a === void 0 ? void 0 : _a.sku) || ((_b = $scope.price) === null || _b === void 0 ? void 0 : _b.c_sku);
                    var skus = [productSku];
                    var accessoriesSkus = [];
                    if ($scope.accessoriesPrices) {
                        accessoriesSkus = $scope.accessoriesPrices
                            .map(function (p) {
                            return p.sku || p.c_sku || '';
                        });
                        Array.prototype.push.apply(skus, accessoriesSkus);
                    }
                    if (skus.length === 0) {
                        return;
                    }
                    if (typeof BasketEventBus === 'undefined') {
                        addToCart(skus);
                    }
                    else {
                        BasketEventBus.post("add-to-basket" /* AddToBasket */, skus, $scope.services, $scope.engravingMessage);
                    }
                };
                var getPrice = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var fetchPriceMethod;
                    return __generator(this, function (_a) {
                        switch ($scope.pType) {
                            case "p" /* Product */:
                                fetchPriceMethod = fetchProductPrice($scope.pId);
                                break;
                            case "g" /* Group */:
                                fetchPriceMethod = fetchGroupPrice($scope.pId);
                                break;
                            default:
                                break;
                        }
                        if (fetchPriceMethod) {
                            $q.when(fetchPriceMethod)
                                .then(function (price) { $scope.price = price; }, initEmptyPrice)
                                .finally(render)
                                .finally(notify);
                        }
                        return [2 /*return*/];
                    });
                }); };
                var notify = function () {
                    if (!$scope.onPriceLoad) {
                        return;
                    }
                    $scope.onPriceLoad({ price: $scope.price });
                };
                var updateFromProduct = function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(!ecomSettings || !ecomSettings.ecomEnabled)) return [3 /*break*/, 1];
                                initEmptyPrice();
                                render();
                                return [3 /*break*/, 3];
                            case 1: return [4 /*yield*/, getPrice()];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); };
                var renderTemplate = function (baseTemplate) {
                    var template = element(baseTemplate);
                    if (ecomSettings && ecomSettings.ecomEnabled && $scope.showPrice) {
                        template.append(priceTemplate);
                    }
                    return template[0].outerHTML;
                };
                var render = function () {
                    var html = '';
                    $element.empty();
                    switch (getAvailabilityState($scope.price)) {
                        case 0 /* Add */:
                            html = renderTemplate(addTemplate);
                            break;
                        case 1 /* PreOrder */:
                            html = renderTemplate(preorderTemplate);
                            break;
                        case 2 /* BackOrder */:
                            html = renderTemplate(backorderTemplate);
                            break;
                        case 3 /* WhereToBuy */:
                        default:
                            html = whereToBuyTemplate;
                            break;
                    }
                    if (html) {
                        var compiled = $compile(html)($scope);
                        $element.append(compiled);
                    }
                };
                $scope.whereToBuyUrl = function () {
                    switch ($scope.segmentType) {
                        case "Business" /* Business */:
                            return '/where-to-buy/partner-locator';
                        default:
                            return '/where-to-buy/retailer-locator';
                    }
                };
                $scope.execute = execute;
                var pIdWatcher;
                var accessoriesPricesWatcher;
                var servicesPriceWatcher;
                $q.when(fetchEcomSetting())
                    .then(function (setting) { ecomSettings = setting; })
                    .finally(function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                $scope.pId = Number($scope.pId);
                                if (!(isNumber($scope.pId) && !isNaN($scope.pId))) return [3 /*break*/, 2];
                                return [4 /*yield*/, updateFromProduct()];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                pIdWatcher = $scope.$watch('pId', function (newValue, oldValue) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (newValue === oldValue || isNaN($scope.pId)) {
                                                    return [2 /*return*/];
                                                }
                                                return [4 /*yield*/, updateFromProduct()];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); });
                                accessoriesPricesWatcher = $scope.$watch('accessoriesPrices', function (newValue, oldValue) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (isEqual(newValue, oldValue)) {
                                                    return [2 /*return*/];
                                                }
                                                return [4 /*yield*/, updateFromProduct()];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); });
                                servicesPriceWatcher = $scope.$watch('servicesPrices', function (newValue, oldValue) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (isEqual(newValue, oldValue)) {
                                                    return [2 /*return*/];
                                                }
                                                return [4 /*yield*/, updateFromProduct()];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); });
                                return [2 /*return*/];
                        }
                    });
                }); });
                $scope.$on('$destroy', function () {
                    if (pIdWatcher !== undefined) {
                        pIdWatcher();
                    }
                    if (accessoriesPricesWatcher !== undefined) {
                        accessoriesPricesWatcher();
                    }
                    if (servicesPriceWatcher !== undefined) {
                        servicesPriceWatcher();
                    }
                });
            },
            restrict: 'E',
            scope: {
                pId: '<',
                pType: '@',
                segmentType: '<?',
                engravingMessage: '<?',
                services: '<?',
                servicesPrices: '<?',
                accessoriesPrices: '<?',
                showPrice: '<?',
                onPriceLoad: '&?',
            },
        };
    },
];
